import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatPhoneNumber} from "page/util/helpers";

function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";
    const email = searchParams.get('email');
    const name = searchParams.get('name');

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;
        params.email = email
        params.name = name

        axios.get(`/admin/users/drops`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">탈퇴회원 > 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>이메일</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '200px'}}
                                                       onChange={ e => {
                                                           searchParams.set('email', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={email}
                                                       placeholder=''/>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>이름</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '200px'}}
                                                       onChange={ e=> {
                                                           searchParams.set('name', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={name}
                                                       placeholder=''/>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginLeft:'10px', marginRight: '20px'}}
                                                        onClick={ () => {
                                                            setPage(1);
                                                            requestSearch();
                                                        }}>
                                                    검색
                                                </button>

                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <div style={{textAlign: 'right', marginRight: '10px', color: 'gray'}}>
                                                탈퇴 회원수: {paginationDto && (paginationDto.totalCount)}
                                            </div>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>이메일</th>
                                                    <th>이름</th>
                                                    <th>전화번호</th>
                                                    <th>가입경로</th>
                                                    <th>사업장수</th>
                                                    <th>탈퇴일</th>
                                                    <th>사유</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.email}</td>
                                                                <td>{item.name}</td>
                                                                <td>{formatPhoneNumber(item.phoneNumber)}</td>
                                                                <td>{item.oauthType ?? "ALLTAX"}</td>
                                                                <td>{item.bizs.length}</td>
                                                                <td>{item.createdAt}</td>
                                                                <td>{item.reason}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-info">
                                                                        <Link to={`/page/user/drop/detail?userDropId=${item.id}`}>보기</Link>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}

export default Main;
